export default __webpack_public_path__ + "static/media/GoodToon.660aac45.png";